export default __webpack_public_path__ + "c86513b3eb1fea689f72d3d07a084328.svg";